// Skills Icons
import htmlIcon from "./images/html.svg"
import cssIcon from "./images/css.svg"
import reactIcon from "./images/react.svg"
import jsIcon from "./images/javascript.svg"
import designIcon from "./images/design.svg"
import codeIcon from "./images/code.svg"
import productIcon from "./images/product.svg"

// Social Icon
import githubIcon from "./images/github.svg"
import codepenIcon from "./images/codepen.svg"
import dribbbleIcon from "./images/dribbble.svg"
import instagramIcon from "./images/instagram.svg"
import twitterIcon from "./images/twitter.svg"
import portfolioIcon from "./images/portfolio-512.png"

// Work
import findTHATMovieIcon from "./images/findTHATMovie.png"
import personalFinanceUiIcon from "./images/personal-finance-ui.png"
import pictureWallIcon from "./images/pictureWall.png"
import devCareerNewsletterIcon from "./images/dev-career-newsletter.png"
import mentalModelIcon from "./images/mental-model.png"

export default {
  //(Please Do Not Remove The comma(,) after every variable)
  //Change The Website Template

  //   Header Details ---------------------
  name: "Dr Alysia Wu",
  headerTagline: [
    //Line 1 For Header
    "Building digital",
    //Line 2 For Header
    "products, brands,",
    //Line 3 For Header
    "and experience",
  ],
  //   Header Paragraph
  headerParagraph: "",

  //Contact Email
  contactEmail: "hello@alysiawu.tech",

  // End Header Details -----------------------

  // Work Section ------------------------
  projects: [
    {
      id: 1, //DO NOT CHANGE THIS (Please)😅
      title: "Find THAT Movie!", //Project Title - Add Your Project Title Here
      para:
        "Find THAT Movie!: I built a movie searching website to find movie by title and genre", // Add Your
      //Project Image - Add Your Project Image Here
      imageSrc: findTHATMovieIcon,
      //Project URL - Add Your Project Url Here
      url: "https://find-that-movie.netlify.app/",
    },
    {
      id: 2, //DO NOT CHANGE THIS (Please)😅
      title: "Personal Finance App", //Project Title - Add Your Project Title Here
      para:
        "Personal Finace: I built personal finance management website UI to help people have a clear overview of their finances", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc: personalFinanceUiIcon,
      //Project URL - Add Your Project Url Here
      url: "https://www.aliceapp.xyz/",
    },
    {
      id: 3, //DO NOT CHANGE THIS (Please)😅
      title: "Text2Image Search Picture Wall App", //Project Title - Add Your Project Title Here
      para:
        "Text2Image: I built this text search image full stack webapp to just for the fun of it 😅", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc: pictureWallIcon,
      //Project URL - Add Your Project Url Here
      url: "https://text2imagesearch.herokuapp.com/",
    },
    {
      id: 4, //DO NOT CHANGE THIS (Please)😅
      title: "Mental Models", //Project Title - Add Your Project Title Here
      para:
        "Mental Models: I really enjoyed all the wisdom instilled in those frameworks, always pull me out of a funk", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc: mentalModelIcon,
      //Project URL - Add Your Project Url Here
      url: "https://mental-models.glideapp.io/",
    },
    {
      id: 5, //DO NOT CHANGE THIS (Please)😅
      title: "Dev Career Newsletter", //Project Title - Add Your Project Title Here
      para:
        "Dev Career Newsletter: A curated list of content for upping your software engineer game", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc: devCareerNewsletterIcon,
      //Project URL - Add Your Project Url Here
      url:
        "https://gdoc.pub/doc/e/2PACX-1vRmEtefZosFxZxQJzqLdOdG5e9ZvDJ9C6UHkdM6AHV4RdwL5HH_7DXoGtWEjZ30pHa4s3uzKTSanezL",
    },

    // {
    //   id: 4, //DO NOT CHANGE THIS (Please)😅
    //   title: "Project Four", //Project Title - Add Your Project Title Here
    //   para:
    //     "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.", // Add Your Service Type Here
    //   //Project Image - Add Your Project Image Here
    //   imageSrc:
    //     "https://images.unsplash.com/photo-1492171983775-a51717616c0d?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxzZWFyY2h8NjB8fHBhc3RlbHxlbnwwfHwwfA%3D%3D&auto=format&fit=crop&w=400&q=60",
    //   //Project URL - Add Your Project Url Here
    //   url: "http://alysiawu.tech/",
    // },
    // {
    //   id: 5, //DO NOT CHANGE THIS (Please)😅
    //   title: "Project Five", //Project Title - Add Your Project Title Here
    //   para:
    //     "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.", // Add Your Service Type Here
    //   //Project Image - Add Your Project Image Here
    //   imageSrc:
    //     "https://images.unsplash.com/photo-1534239143101-1b1c627395c5?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxzZWFyY2h8NzZ8fHBhc3RlbHxlbnwwfHwwfA%3D%3D&auto=format&fit=crop&w=400&q=60",
    //   //Project URL - Add Your Project Url Here
    //   url: "http://alysiawu.tech/",
    // },
    // {
    //   id: 6, //DO NOT CHANGE THIS (Please)😅
    //   title: "Project Six", //Project Title - Add Your Project Title Here
    //   para:
    //     "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.", // Add Your Service Type Here
    //   //Project Image - Add Your Project Image Here
    //   imageSrc:
    //     "https://images.unsplash.com/photo-1517479149777-5f3b1511d5ad?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxzZWFyY2h8MTAyfHxwYXN0ZWx8ZW58MHx8MHw%3D&auto=format&fit=crop&w=400&q=60",
    //   //Project URL - Add Your Project Url Here
    //   url: "http://alysiawu.tech",
    // },

    /*
    If You Want To Add More Project just Copy and Paste This At The End (Update the id Respectively)
    ,{
        id: 5,
        title: 'Project Five',
        para: 'Something Amazing',
        imageSrc: "",
        url: ''
    }
    */
  ],

  // End Work Section -----------------------

  // About Secton --------------
  aboutParaOne:
    "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
  aboutParaTwo:
    "It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
  aboutParaThree:
    "It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
  aboutImage: portfolioIcon,

  //   End About Section ---------------------

  // Skills Section ---------------

  //   Import Icons from the top and link it here

  skills: [
    // {
    //   id: 1,
    //   img: htmlIcon,
    //   para:
    //     "",
    // },
    // {
    //   id: 2,
    //   img: cssIcon,
    //   para:
    //     "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    // },
    // Design thinking is a human-centric creative process to build meaningful and effective solutions for people
    // React is a JavaScript library for building user interfaces.Declarative: React makes it painless to create interactive UIs.Design simple views for each state in your application, and React will efficiently update and render just the right components when your data changes.Declarative views make your code more predictable, simpler to understand, and easier to debug. | Component - Based: Build encapsulated components that manage their own state, then compose them to make complex UIs.Since component logic is written in JavaScript instead of templates, you can easily pass rich data through your app and keep state out of the DOM. | Learn Once, Write Anywhere: We don't make assumptions about the rest of your technology stack, so you can develop new features in React without rewriting existing code. React can also render on the server using Node and power mobile apps using React Native.
    {
      id: 3,
      img: productIcon,
      para:
        "🚀 Product launching: identifying a market opportunity, defining the problem, developing a proper solution for that problem and validating the solution with real users",
    },
    {
      id: 4,
      img: reactIcon,
      para:
        "⚛️🔥 Product Building: Using MERN stack, React Native and Firebase BE for launching MVP and prototype in days and weeks not in months!.",
    },
    {
      id: 5,
      img: designIcon,
      para:
        "🚀 Product design: human-centric creative process to build meaningful and effective solutions for people",
    },
    // {
    //   id: 6,
    //   img: codeIcon,
    //   para:
    //     "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    // },
  ],

  // End Skills Section --------------------------

  //   Promotion Section --------------------------

  promotionHeading: "Heading",
  promotionPara:
    "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
  // End Promotion Section -----------------

  //   Contact Section --------------

  contactSubHeading: "Let's create your next experience together",
  social: [
    // Add Or Remove The Link Accordingly

    { img: githubIcon, url: "https://github.com/alysiawu" },
    {
      img: twitterIcon,
      url: "https://twitter.com/AlysiaWenjieWu",
    },
    // {
    //   img: codepenIcon,
    //   url: "https://www.codepen.com/",
    // },
    // {
    //   img: dribbbleIcon,
    //   url: "https://dribbble.com/chetanverma",
    // },
    // {
    //   img: instagramIcon,
    //   url: "https://www.instagram.com/",
    // },
  ],

  // End Contact Section ---------------
}

// Thanks for using this template, I would love to hear from you contact me at hello@chetanverma.com
